// extracted by mini-css-extract-plugin
module.exports = {"content":"HappenRow_content__USH_C","texts":"HappenRow_texts__AHCNx","title":"HappenRow_title__fugmc","desc":"HappenRow_desc__voy7p"};